import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export type LineMarketSlotCoalesceConfig = {
    sports: ReadonlySet<string>;
    inPlayOnly: boolean;
    /**
     * Sticky line markets kept per grouping name, keyed by sport id.
     * Sports not listed fall back to `defaultMaxSlotsPerGroup`.
     */
    maxSlotsPerGroupBySport: Readonly<Record<string, number>>;
    defaultMaxSlotsPerGroup: number;
};

export const LINE_MARKET_SLOT_COALESCE_CONFIG: LineMarketSlotCoalesceConfig = {
    sports: new Set(['basketball', 'tennis']),
    inPlayOnly: true,
    maxSlotsPerGroupBySport: {
        basketball: 1,
        tennis: 3,
    },
    defaultMaxSlotsPerGroup: 1,
};

export const shouldEnableLineMarketSlotCoalesce = (
    eventId: EventId,
    config: LineMarketSlotCoalesceConfig = LINE_MARKET_SLOT_COALESCE_CONFIG
): boolean => {
    const event = eventId.getEventModel();
    if (event === null) {
        return false;
    }

    if (config.sports.has(event.sport) === false) {
        return false;
    }

    if (config.inPlayOnly && event.timeSettingsStarted === false) {
        return false;
    }

    return true;
};

export const getLineMarketSlotCoalesceMaxSlots = (
    eventId: EventId,
    config: LineMarketSlotCoalesceConfig = LINE_MARKET_SLOT_COALESCE_CONFIG
): number => {
    const event = eventId.getEventModel();
    if (event === null) {
        return config.defaultMaxSlotsPerGroup;
    }

    return config.maxSlotsPerGroupBySport[event.sport] ?? config.defaultMaxSlotsPerGroup;
};
